export const GENERATE_OTP = 'GENERATE_OTP'
export const DELETE_OTP = 'DELETE_OTP';
export const VERIFY_OTP = 'VERIFY_OTP';


export const PURPOSE = {
    LOGIN: "LOGIN",
    FORGOT_PASSWORD: "FORGOT_PASSWORD",
    FORGOT_PASSWORD_MOBILE: "FORGOT_PASSWORD_MOBILE",
    FORGOT_PASSWORD_MOB_EM: "FORGOT_PASSWORD_MOB_EM",
    MOBILE_VERIFICATION: "MOBILE_VERIFICATION",
    USER_SIGNUP: "USER_SIGNUP",
    UPDATE_MOBILE: "UPDATE_MOBILE",
    UPDATE_MOBILE_V2: "UPDATE_MOBILE_V2",
    UPGRADE_USER: "UPGRADE_USER",
    LINK_ACCOUNT: "LINK_ACCOUNT",
    ONECHECK_SOCIAL_SIGNUP: "ONECHECK_SOCIAL_SIGNUP",
    MONEY_OUT: "MONEY_OUT",
    WALLET_PAY: "WALLET_PAY",
    WALLET_LOAD: "WALLET_LOAD",
    WALLET_ENQUIRY: "WALLET_ENQUIRY",
    LOGIN_WITH_EMAIL_OTP: "LOGIN_WITH_EMAIL_OTP",
    LOGIN_WITH_MOBILE_OTP: "LOGIN_WITH_MOBILE_OTP",
    SIGNUP_WITH_OTP: "SIGNUP_WITH_OTP",
    VERIFY_EMAIL_MOBILE_ONLY: "VERIFY_EMAIL_MOBILE_ONLY",
    VERIFY_EMAIL_USING_OTP: "VERIFY_EMAIL_USING_OTP",
    VERIFY_OTP_FOR_TWOFA: "VERIFY_OTP_FOR_TWOFA",
    VERIFYOTP_WRONG_PWD: "VERIFYOTP_WRONG_PWD",
    VERIFY_OLD_MOBILE: "VERIFY_OLD_MOBILE",
    CHANGEPWD_MOB_VERIFIED: "CHANGEPWD_MOB_VERIFIED",
    FOS_APP_USER_VERIFICATION: "FOS_APP_USER_VERIFICATION",
    PAYMENTS_OTP: "PAYMENTS_OTP",
}